import { SET_LOADING } from '../actions';
import {REMOVE_LOADING} from '../actions/index';

export default ( state = [], action ) => {
	switch ( action.type ) {
		case SET_LOADING:
			return  [...state,action.payload];
			break;
		case REMOVE_LOADING:
			let commIndex = state.indexOf(action.payload);
			let newState = [...state.slice(0,commIndex), ...state.slice(commIndex +1)];
			return [ ...newState ];
	}
	return state;
}